// BASE URL
export const baseURL = process.env.REACT_APP_API_BASE_URL;

// AUTH SECTION URL
export const login = "api/auth/login";
export const googleLogin = "api/auth/verify-google";
export const signup = "api/auth/signup";
export const forgotPassword = "api/auth/reset-password";
export const getLinkOfPassword = "api/auth/forgot-password";
export const newAccessToken = "api/auth/token";
export const emailAuth="api/auth/email"

//Support contact
export const support="api/support"

// PROFILE SECTION URL
export const profileCreationAPI = "api/users/profile";
export const businessProfileCreationAPI = "api/company";
export const profileImageAPI = "api/users/profile/image";
export const profilePortfolioAPI = "api/users/profile/portfolio";
export const followUserAPI = "api/users/follow";
export const unfollowUserAPI = "api/users/unfollow";
export const domainAPI = "api/domains";
export const categoriesAPI = "api/categories";
export const getProfileUser = "api/users/profile";
export const getCitiesAPI = "";
export const getStatesAPI = "api/locations/states";

// FILES API
export const filesAPI = `${baseURL}api/files`;

// PROJECTS API
export const getAllProjects = "api/jobs";
export const postProject = "api/jobs";

// APPLY PROJECTS
export const applyProject = "api/job-applications";

// SOCIAL FEED API
export const newSocialPostMedia = "api/media";
export const getAllPostsAPI = "api/post";

//REQUEST EMAIL API
export const getRequestEmailListAPI = "api/users/connections/requests";
export const getReceivedEmailListAPI = "api/users/connections/received";

//NOTIFICATIONS API
export const notifications = "api/notifications";
// export const categoriesAPI = "https://be91-103-143-8-45.ngrok-free.app/api/categories"

//GET PAYMENT PLAN API
export const subscriptionPlan = "api/subscription/plan";
export const subscriptionInitiate = "api/subscription/initiate";
export const activePlan = "api/subscription/me";

//Call back URL
export const callBack = `${baseURL}api/subscription/callback`;

//-------ADMIN API'S---------

export const ADMIN_API_ENDPOINTS = {
  //User Management
  USERS: "api/users",
  USER_STATUS: "api/users/status",
  //Project Monitoring
  PROJECTS: "api/jobs/content",
  PROJECT_STATUS: "api/jobs/status",
  PROJECT_FLAG_STATUS: "api/jobs/flag-status",
  //Post Monitoring
  POSTS: "api/post/content",
  POST_STATUS: "api/post/status",
  POST_FLAG_STATUS: "api/post/flag-status",
  //SUBSCRIPTIONS
  SUBSCRIPTIONS: "api/subscription/user-plans",
  SUBSCRIPTIONS_STATUS: "api/subscription/status",
  //PAYMENTS
  PAYMENTS: "/api/payments",
  PAYMENTS_STATUS: "api/payments/status",
  // DASHBOARD
  METRICS: "api/dashboard/metrics",
  USERS_BY_INDUSTRY: "api/dashboard/industry",
  USERS_BY_PREFERENCE: "api/dashboard/preference",
  MEMBERSHIP: "/api/dashboard/membership",
  USERDETAILS: "/api/users/me",
  GROSS_VOLUME: "api/dashboard/plan-counts",
  SIGNUP_COUNT: "api/dashboard/user-signup-count",
  PROFILE_INCOMPLETE: "profile-incomplete-mail",
};
